import { deepClone } from "./util";

export const getMenuItemFromAllMenu = (menuAll, pendingOpenPath) => {
  let openItem = {};
  let findItem = {};
  menuAll.forEach((itemA, i) => {
    // 在一级菜单中出现
    if (itemA.path === pendingOpenPath) {
      openItem.itemA = itemA;
      openItem.level = 1;
      openItem.levelAindex = i;
      findItem = itemA;
    } else {
      // 不在一级菜单中出现
      const childrenB = itemA.children;
      if (childrenB && Array.isArray(childrenB)) {
        childrenB.forEach((itemB, j) => {
          // 在二级菜单中出现
          if (itemB.path === pendingOpenPath) {
            openItem.level = 2;
            openItem.levelAindex = i;
            openItem.levelBindex = j;
            openItem.itemA = itemA;
            openItem.itemB = itemB;
            findItem = itemB;
          } else {
            // 不在二级菜单中出现
            const childrenC = itemB.children;
            if (childrenC && Array.isArray(childrenC)) {
              childrenC.forEach((itemC, k) => {
                // 最多只有三级
                if (itemC.path === pendingOpenPath) {
                  openItem.level = 3;
                  openItem.levelAindex = i;
                  openItem.levelBindex = j;
                  openItem.levelCindex = k;
                  openItem.itemA = itemA;
                  openItem.itemB = itemB;
                  openItem.itemC = itemC;
                  findItem = itemC;
                } else {
                  const childrenD = itemC.children;
                  if (childrenD && Array.isArray(childrenD)) {
                    childrenD.forEach((itemD, l) => {
                      // 最多只有三级
                      if (itemD.path === pendingOpenPath) {
                        openItem.level = 4;
                        openItem.levelAindex = i;
                        openItem.levelBindex = j;
                        openItem.levelCindex = k;
                        openItem.levelDindex = l;
                        openItem.itemA = itemA;
                        openItem.itemB = itemB;
                        openItem.itemC = itemC;
                        openItem.itemD = itemD;
                        findItem = itemD;
                      }
                    })
                  }
                }
              })
            }
          }
        })
      }
    }
  })
  openItem.findItem = findItem;
  return openItem;
}

export const getLastOpenMenuItem = () => {
  const lastOpenMenu = sessionStorage.getItem('lastOpenMenu') || '{}';
  const item = JSON.parse(lastOpenMenu);
  if (item.path) {
    return item;
  }
  sessionStorage.removeItem('lastOpenMenu');
  return {};
}
